import { Backdrop, Button, CircularProgress, Box, FormControl, InputLabel, TextField, Typography, Stack, Select, MenuItem } from "@mui/material";
import React, { useEffect } from "react";
import { Context } from "../../App";
import { AccessList, SuperAdmAccessList } from "../../conf";

export default function UserForm({user, close, setUsers, showResult}) {
    const { setIsConnected } = React.useContext(Context);
    const actualUser = JSON.parse(sessionStorage.getItem('user'));
    const [loading, setLoading] = React.useState(true);
    const [events, setEvents] = React.useState(user?.events || []);

    const [genre, setGenre] = React.useState(user?.genre||'Mr');
    const [nom, setNom] = React.useState(user?.nom||'');
    const [prenom, setPrenom] = React.useState(user?.prenom||'');
    const [mail, setMail] = React.useState(user?.mail||'');
    const [tel, setTel] = React.useState(user?.tel||'');
    const [voie, setVoie] = React.useState(user?.voie||'');
    const [zip_code, setZipCode] = React.useState(user?.zip_code||'');
    const [ville, setVille] = React.useState(user?.ville||'');
    const [adresse_complement, setAdresseComplement] = React.useState(user?.adresse_complement||'');

    const [role, setRole] = React.useState(user?.role||'user');
    const [access, setAccess] = React.useState(user?.access||[]);
    const [userEvents, setUserEvents] = React.useState(user?.events||[]);

    const [msg, setMsg] = React.useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        if (!user) return;
        
        setLoading(true);
        const query = new URLSearchParams({_id: user._id}).toString();
        const body = { genre, nom, prenom, mail, tel, voie, zip_code, ville, adresse_complement, role, access, events: userEvents };

        fetch(`${process.env.REACT_APP_API_URL}/adm/users?`+query, {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify(body),
        })
        .then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                } if (!response.ok) {
                    const text = await response.text();
                    setMsg((![500, 404].includes(response.status) ? text : null) || 'Erreur lors de l\'enregistrement');
                }else {
                    const json = await response.json();
                    setUsers(old=> old.map(u => u._id === json._id ? json : u));
                    const actualUser = JSON.parse(sessionStorage.getItem('user'));
                    if (actualUser && actualUser._id === json._id) {
                        sessionStorage.setItem('user', JSON.stringify(json));
                    }
                    setMsg('');
                    close();
                }
                setLoading(false);
            }
        })
        .catch(error => {
            setLoading(false);
            console.error('Erreur lors de l\'inscription :', error);
            alert('Une erreur est survenue. Veuillez réessayer plus tard.');
        });
    }

    async function ReinitPwd() {
        if (window.confirm('Êtes-vous sûr de vouloir réinitialiser le mot de passe de cet utilisateur ?')) {
            setLoading(true);
            console.log(process.env.REACT_APP_API_URL+'/user/'+user._id+'/reinit')
            fetch(`${process.env.REACT_APP_API_URL}/user/${user._id}/reinit`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token')
                },
            })
            .then(async response => {
                const token = response.headers.get('x-auth-token');
                if (response.status === 401) {
                    sessionStorage.clear();
                    setIsConnected(false);
                } else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                    } if (!response.ok) {
                        const text = await response.text();
                        setMsg((response.status!==500 ? text : null) || 'Erreur lors de la réinitialisation du mot de passe');
                    } else {
                        setMsg('Mot de passe réinitialisé avec succès');
                        showResult(true);
                    }
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                console.error('Erreur lors de la réinitialisation du mot de passe :', error);
                alert('Une erreur est survenue. Veuillez réessayer plus tard.');
            });
        }
    }

    useEffect(()=> {
        if(role!=='admin') {
            setAccess([]);
            setUserEvents([]);
        }
    }, [role])

    useEffect(() => {
        const query = new URLSearchParams({}).toString();

        fetch(process.env.REACT_APP_API_URL.concat('/adm/events?'+query), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setEvents(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching projects:", error);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    return <Box component='form' onSubmit={handleSubmit} sx={{ display:'flex', flexDirection:'column', mt: 2, px: 2, rowGap:2, minWidth: '800px' }}>

        {msg && <Typography variant="body1" color="error" sx={{ mb: 2 }}>{msg}</Typography>}

        <TextField select label="Civilité" variant="outlined" value={genre} required sx={{ width: '30%' , minWidth: '150px' }}
        onChange={(e) => setGenre(e.target.value)} slotProps={{ select: {native: true} }}>
            <option value="Mme">Madame</option>
            <option value="Mr">Monsieur</option>
        </TextField>

        <Stack direction="row" spacing={1}>
            <TextField fullWidth label="Nom" variant="outlined" value={nom} required
            onChange={(e) => setNom(e.target.value)} />
            <TextField fullWidth label="Prénoms" variant="outlined" value={prenom} required
            onChange={(e) => setPrenom(e.target.value)} />
        </Stack>

        <Stack direction="row" spacing={1}>
            <TextField fullWidth label="Adresse e-mail" variant="outlined" value={mail} required type="email"
            onChange={(e) => setMail(e.target.value)} />
            <TextField type="tel" label="GSM" variant="outlined" value={tel} sx={{ width: '400px' }} 
            slotProps={{ input: { pattern: "^(\\+|0)[1-9][0-9]{12}$" } }}
            onChange={(e) => setTel(e.target.value)} />
        </Stack>

        <Typography variant="h6" sx={{ mt: 2 }}>Adresse</Typography>
        <TextField fullWidth label="Numéro et nom de la voie" variant="standard" value={voie} sx={{ mt: -2 }}
        onChange={(e) => setVoie(e.target.value)} />
        <TextField fullWidth label="Complément d'adresse" variant="standard" value={adresse_complement}
        onChange={(e) => setAdresseComplement(e.target.value)} />
        <Stack direction="row" spacing={3}>
            <TextField label="Code postal" variant="standard" value={zip_code} required sx={{ width: '200px' }}
            onChange={(e) => setZipCode(e.target.value)} />
            <TextField fullWidth label="Ville" variant="standard" value={ville} required
            onChange={(e) => setVille(e.target.value)} />
        </Stack>

        <Typography variant="h6" sx={{ mt: 2 }} color="focus2">Rôle et Accès</Typography>
        <TextField select label="Rôle" variant="outlined" value={role} required sx={{ minWidth: '200px', width: '30%' }}
        onChange={(e) => setRole(e.target.value)} slotProps={{ select: {native: true} }}>
            <option value="user">Utilisateur</option>
            <option value="admin">Administrateur</option>
            {actualUser.role==='super admin'&&<option value="super admin">Super Admin</option>}
        </TextField>

        {role==='admin'&&<Stack direction="row" spacing={1}>
            <FormControl fullWidth>
                <InputLabel id="mon-label">Choix des accès</InputLabel>
                <Select multiple fullWidth label="Accès" variant="outlined" value={access} required
                    onChange={(e) => setAccess(e.target.value)}>
                    {(role==='super admin' ? [...AccessList, ...SuperAdmAccessList] : AccessList).sort((a,b)=>a.label<b.label ? -1 : 1).map((a, i) => (
                        <MenuItem key={i} value={a.label}>{a.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl fullWidth>
                <InputLabel id="mon-label">Choix des évènements</InputLabel>
                <Select multiple fullWidth label="Évènements" variant="outlined" value={userEvents}
                    onChange={(e) => setUserEvents(e.target.value)}>
                    {events.sort((a,b)=>a.titre<b.titre ? -1 : 1).map((event, i) => (
                        <MenuItem key={i} value={event._id}>{event.titre}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Stack>}

        <Button variant="outlined" color="focus2" onClick={ReinitPwd} sx={{ my: 2, alignSelf:'start' }}>
            Réinitialiser le mot de passe
        </Button>

        {msg && <Typography variant="body1" color="error" sx={{ my: 2 }}>{msg}</Typography>}

        <Button variant="contained" type='submit' sx={{alignSelf: 'center', px: 5, mb: 2}}>Enregistrer</Button>

        <Backdrop open={loading}><CircularProgress/></Backdrop>

    </Box>
}